import React from 'react'
import { useTranslation } from 'react-i18next'

export interface EnumAsOptions<TEnum> {
  key: TEnum[keyof TEnum]
  text: string
  value: TEnum[keyof TEnum]
}

export function useEnumAsOptions<TEnum extends object>(enumerable: TEnum, name: string): EnumAsOptions<TEnum>[] {
  const { t, i18n } = useTranslation()

  return React.useMemo(() => {
    const keys = Object.keys(enumerable) as (keyof TEnum)[]

    return keys.map(key => {
      const value = enumerable[key]

      return {
        key: value,
        text: t(`Enum.${name}`, { context: value }),
        value
      }
    })
  }, [enumerable, name, i18n.language])
}
